import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiService from '../services/api';
import '../styles/StaffPages.css';
import headerImage from '../assets/images/header.png';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [uid, setUid] = useState('');
  const [token, setToken] = useState('');
  const [formData, setFormData] = useState({
    new_password: '',
    confirm_password: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('form');

  useEffect(() => {
    let paramUid = searchParams.get('uid');
    let paramToken = searchParams.get('token');
    if (!paramUid || !paramToken) {
      const currentUrl = window.location.href;
      const urlParams = new URLSearchParams(currentUrl.split('?')[1] || '');
      paramUid = paramUid || urlParams.get('uid');
      paramToken = paramToken || urlParams.get('token');
    }
    if (paramUid) setUid(paramUid);
    if (paramToken) setToken(paramToken);
  }, [searchParams]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: '',
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (formData.new_password !== formData.confirm_password) {
      setErrors({ confirm_password: 'Passwords do not match.' });
      return;
    }
    if (formData.new_password.length < 8) {
      setErrors({ new_password: 'Password must be at least 8 characters.' });
      return;
    }

    if (!uid || !token) {
      setErrors({ general: 'Invalid or expired reset link. Please request a new one.' });
      return;
    }

    setLoading(true);
    try {
      await apiService.resetPassword({
        uid,
        token,
        new_password: formData.new_password,
      });
      setStatus('success');
    } catch (error) {
      if (error.response?.status === 400 && error.response?.data) {
        const data = error.response.data;
        if (data.token) setErrors({ general: Array.isArray(data.token) ? data.token[0] : data.token });
        else if (data.new_password) setErrors({ new_password: Array.isArray(data.new_password) ? data.new_password[0] : data.new_password });
        else setErrors({ general: 'Invalid or expired link. Please request a new password reset.' });
      } else {
        setErrors({ general: 'Something went wrong. Please try again or request a new link.' });
      }
    } finally {
      setLoading(false);
    }
  };

  if (status === 'success') {
    return (
      <div className="d-flex align-center justify-center" style={{ minHeight: '100vh' }}>
        <div className="container-narrow">
          <div className="card" style={{ maxWidth: '500px', margin: '0 auto', padding: '32px' }}>
            <div className="text-center mb-4">
              <img src={headerImage} alt="HomeCrowd" style={{ maxWidth: '250px', height: 'auto', marginBottom: '20px' }} />
            </div>
            <div className="text-center">
              <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#111111', marginBottom: '12px' }}>
                Password reset successfully
              </h2>
              <p style={{ fontSize: '16px', color: '#4b5563', marginBottom: '32px' }}>
                You can now sign in with your new password.
              </p>
              <button
                onClick={() => navigate('/login/')}
                className="staff-page-button"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                <span className="staff-page-button-text">Go to login</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-center justify-center" style={{ minHeight: '100vh' }}>
      <div className="container-narrow">
        <div className="card" style={{ maxWidth: '400px', margin: '0 auto', padding: '32px' }}>
          <div className="text-center mb-4">
            <img src={headerImage} alt="HomeCrowd" style={{ maxWidth: '250px', height: 'auto', marginBottom: '20px' }} />
          </div>
          <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#111111', marginBottom: '8px', textAlign: 'center' }}>
            Set new password
          </h1>
          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px', textAlign: 'center' }}>
            Enter your new password below.
          </p>

          {errors.general && (
            <div className="alert alert-error" style={{ marginBottom: '16px' }}>
              {errors.general}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">New password</label>
              <input
                type="password"
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
                required
                minLength={8}
                className="form-input"
                placeholder="At least 8 characters"
              />
              {errors.new_password && (
                <div className="text-error mt-1" style={{ fontSize: '14px' }}>{errors.new_password}</div>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Confirm password</label>
              <input
                type="password"
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Repeat new password"
              />
              {errors.confirm_password && (
                <div className="text-error mt-1" style={{ fontSize: '14px' }}>{errors.confirm_password}</div>
              )}
            </div>
            <button
              type="submit"
              className="staff-page-button"
              style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}
              disabled={loading}
            >
              <span className="staff-page-button-text">{loading ? 'Resetting...' : 'Reset password'}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
